import React, { forwardRef } from 'react';

const CrmPageSurface = forwardRef(({
  children,
  fullBleed = false,
  className = '',
  ...props
}, ref) => (
  <section
    ref={ref}
    className={`crm-page-surface ${fullBleed ? 'crm-page-surface--full-bleed' : ''} ${className}`.trim()}
    {...props}
  >
    {children}
  </section>
));

CrmPageSurface.displayName = 'CrmPageSurface';

export default CrmPageSurface;
